import { render, staticRenderFns } from "./FeedbackItem.vue?vue&type=template&id=1635b17f&scoped=true&lang=pug&"
import script from "./FeedbackItem.vue?vue&type=script&lang=js&"
export * from "./FeedbackItem.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackItem.vue?vue&type=style&index=0&id=1635b17f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635b17f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
